var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_c('el-button',{attrs:{"plain":""},on:{"click":_vm.open1}},[_vm._v(" 可自动关闭 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }